// utils/enquiryUtils.js

/**
 * Validates the enquiry form data.
 * @param {object} formData - The form data: { name, email, mobile, message }
 * @returns {object} { errors, isValid } - An object containing error messages and validity status.
 */
export const validateEnquiryForm = (formData) => {
    let errors = {};
    let isValid = true;

    if (!formData.name.trim()) {
        errors.name = 'Name is required.';
        isValid = false;
    }

    if (!formData.email.trim()) {
        errors.email = 'Email is required.';
        isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
        errors.email = 'Email address is invalid.';
        isValid = false;
    }

    // Basic mobile validation (10 to 15 digits, ignoring common separators)
    const mobileValue = formData.mobile.replace(/[\s-()]/g, '');
    if (!mobileValue) {
        errors.mobile = 'Mobile number is required.';
        isValid = false;
    } else if (!/^\d{10,15}$/.test(mobileValue)) {
        errors.mobile = 'Mobile number is invalid (10-15 digits expected).';
        isValid = false;
    }

    return { errors, isValid };
};

/**
 * UPDATED: Submits the enquiry form data to the backend API endpoint using fetch.
 * @param {object} formData - The validated form data.
 * @returns {Promise<object>} A promise that resolves with the server response data.
 */
export const submitEnquiryForm = async (formData) => {
    // CORRECTED ENDPOINT: This matches your desired backend route
    const API_ENDPOINT = 'http://localhost:3000/v1/enquiry/save_enquiry' || 'http:policysaath.com/v1/enquiry/save_enquiry'; 

    const response = await fetch(API_ENDPOINT, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
    });

    const data = await response.json();

    if (!response.ok) {
        // Throw an error with the message provided by the backend
        throw new Error(data.message || 'Failed to submit enquiry due to a server error.');
    }

    // Return the successful response data
    return data;
};